<div class="dialog-container">
  <button
    mat-icon-button
    mat-dialog-close="cancel"
    aria-label="Close dialog"
    class="close-icon"
    (click)="cancelUpdate()"
  >
    <span class="material-symbols-outlined">close</span>
  </button>
  <span class="material-symbols-outlined warning-icon">info</span>
  @if (
    _data.isUpdate &&
    !_data.ingredientMapping &&
    !_data.nutritionalInfoData &&
    !_data.priceApproverEmail &&
    !_data.sendASPRequest
  ) {
    <div class="confirmation-title">
      {{ "updateAspConfirmation" | translate }} {{ _data.regionName }}?
    </div>
  }
  @if (
    !_data.isUpdate &&
    !_data.ingredientMapping &&
    !_data.nutritionalInfoData &&
    !_data.priceApproverEmail &&
    !_data.sendASPRequest
  ) {
    <div class="confirmation-title">
      {{ "addAspRegionConfirmation" | translate }} {{ _data.regionName }}?
    </div>
  }
  @if (_data.ingredientMapping) {
    <div class="confirmation-title">
      {{ "ingrediantMappingUpdateDialog" | translate }}
      {{ _data.ingrdientId }}?
    </div>
  }

  @if (_data.nutritionalInfoData) {
    <div class="confirmation-title">
      {{ "nutritionalInfoUpdateDialog" | translate }} {{ _data.countryName }}?
    </div>
  }

  @if (_data.priceApproverEmail) {
    <div class="confirmation-title">
      {{ "deletePriceAdmin" | translate }} {{ _data.countryName }}?
    </div>
  }

  @if (_data.sendASPRequest) {
    <div class="confirmation-title">
      {{ "sendASPRequest" | translate }} {{ _data.regionName }}
    </div>
  }

  @if (
    !_data.ingredientMapping &&
    !_data.nutritionalInfoData &&
    !_data.priceApproverEmail &&
    !_data.sendASPRequest
  ) {
    <div class="confirmation-subtitle">
      {{ "aspFor" | translate }}
      {{ _data.newValue.ingredientName }}
      @if (_data.isUpdate) {
        {{ "changedFrom" | translate }}
        {{ _data.oldValue | translate }}
        {{ "to" | translate }}
        {{ _data.updatedIngredientASP }}
        {{ "usd/kg" | translate }}
      }
      @if (!_data.isUpdate) {
        {{ "definedAs" | translate }} {{ _data.updatedIngredientASP }}
        {{ "usd/kg" | translate }}
      }
    </div>
  }

  @if (_data.sendASPRequest) {
    <div class="inline-group">
      <div class="inline-item">
        <mat-label class="input-label">{{ "oldValue" | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput disabled [value]="_data.oldValue" />
        </mat-form-field>
      </div>

      <div class="inline-item">
        <mat-label class="input-label">{{ "newValue" | translate }}*</mat-label>
        <mat-form-field appearance="outline">
          <input matInput required [(ngModel)]="newPrice" />
        </mat-form-field>
      </div>
    </div>
  }

  @if (_data.priceApproverEmail) {
    <div class="confirmation-subtitle">
      {{
        ("deletePriceAdminMessage" | translate)
          .replace("message1", `${_data.priceApproverEmail}`)
          .replace("message2", `${_data.regionName}`)
      }}
    </div>
  }

  <mat-dialog-actions
    [align]="_data.sendASPRequest ? 'start' : 'center'"
    class="new-recipe-dialog-actions"
  >
    <button
      mat-flat-button
      class="cancel-button"
      mat-dialog-close="cancel"
      (click)="cancelUpdate()"
    >
      {{ "cancel" | translate }}
    </button>
    @if (_data.sendASPRequest) {
      <button
        (click)="sendUpdatedPrice()"
        mat-flat-button
        color="primary"
        class="save-button"
        [mat-dialog-close]="'save'"
        [disabled]="!newPrice() || newPrice().toString().trim().length === 0"
      >
        {{ "send" | translate }}
      </button>
    } @else {
      <button
        (click)="saveUpdatedPrice()"
        mat-flat-button
        color="primary"
        class="save-button"
        [mat-dialog-close]="'save'"
      >
        @if (_data.priceApproverEmail || _data.sendASPRequest) {
          {{ "confirm" | translate }}
        } @else {
          {{ "save" | translate }}
        }
      </button>
    }
  </mat-dialog-actions>
</div>
